import { Controller } from 'react-hook-form';
import { Input } from '../../../../components/common/Input';

type DateRangeFilterProps = {
  fieldName: string;
  control: any;
};

export const DateRangeFilter = ({ fieldName, control }: DateRangeFilterProps) => {
  return (
    <Controller
      name={fieldName}
      control={control}
      defaultValue={['', '']}
      rules={{
        validate: (value: string[]) => {
          const from = value?.[0];
          const to = value?.[1];
          if (from && to) {
            const fromDate = new Date(from);
            const toDate = new Date(to);
            if (fromDate > toDate) {
              return 'From date must be before or equal to To date';
            }
          }
          return true;
        }
      }}
      render={({ field, fieldState }) => {
        const onDateChange = (index: 0 | 1, value: string) => {
          const arr = Array.isArray(field.value) ? [...field.value] : ['', ''];
          arr[index] = value;
          field.onChange(arr);
        };

        const fromVal = (field.value && field.value[0]) || '';
        const toVal = (field.value && field.value[1]) || '';

        return (
          <div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="text-xs font-medium text-gray-600 block mb-1">From</label>
                <Input
                  type="date"
                  value={fromVal}
                  onChange={(e) => onDateChange(0, (e.target as HTMLInputElement).value)}
                  onClick={(e) => {
                    try {
                      (e.target as HTMLInputElement).showPicker?.();
                    } catch (error) {
                      // showPicker() not supported in this browser, fallback to default behavior
                    }
                  }}
                  placeholder="From"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-600 block mb-1">To</label>
                <Input
                  type="date"
                  value={toVal}
                  onChange={(e) => onDateChange(1, (e.target as HTMLInputElement).value)}
                  onClick={(e) => {
                    try {
                      (e.target as HTMLInputElement).showPicker?.();
                    } catch (error) {
                      // showPicker() not supported in this browser, fallback to default behavior
                    }
                  }}
                  placeholder="To"
                />
              </div>
            </div>
            {fieldState.error && (
              <div className="text-sm text-red-600 mt-1">{fieldState.error.message}</div>
            )}
          </div>
        );
      }}
    />
  );
};